import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurycabserviceindelhi() {



  const cardData =
  {
    keyword: 'Luxury Cab Services in Delhi',
    heading: 'Aaryan Travels: Luxury Cab Services in Delhi',
    headingDescription: ' Aaryan Travels offers premium Luxury Cab Services in Delhi for business executives, VIP guests, weddings, and special occasions. Whether you need a high-end sedan, luxury SUV, or premium chauffeur-driven car for airport transfers, corporate meetings, hotel pickups, or city tours, our fleet delivers unmatched comfort and elegance. With uniformed chauffeurs, well-maintained vehicles, bottled water, and Wi-Fi on request, we provide a dignified and professional travel experience. From Connaught Place to Aerocity, South Delhi to Gurgaon, Aaryan Travels ensures punctual and smooth luxury cab services across the NCR region, tailored to those who value style, convenience, and prestige.',

    top: 'Top Places to Visit in Delhi with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Red Fort (Lal Qila)",
    "description": "Built in 1648 by Mughal Emperor Shah Jahan, the Red Fort is a UNESCO World Heritage Site known for its massive red sandstone walls and grand architecture. The fort houses palaces, museums, and gardens reflecting Mughal splendor. The evening sound-and-light show narrates its glorious history. Every Independence Day, the Prime Minister hoists the national flag here. Red Fort is Delhi’s enduring symbol of power and pride."
  },
  {
    "title": "India Gate",
    "description": "India Gate is a majestic war memorial built in honor of Indian soldiers who sacrificed their lives during World War I. Surrounded by lush lawns, it is a popular spot for evening strolls and picnics. The Amar Jawan Jyoti flame burns eternally in tribute to the martyrs. Illuminated beautifully at night, it attracts both tourists and locals. India Gate is Delhi’s national landmark of remembrance."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar is the world’s tallest brick minaret standing at 73 meters, built in 1193 by Qutb-ud-din Aibak. Its intricate carvings and Quranic inscriptions showcase Indo-Islamic architecture. The surrounding Qutub complex includes ancient mosques and the Iron Pillar, known for its rust-resistant properties. Qutub Minar is Delhi’s towering masterpiece of history and craftsmanship."
  },
  {
    "title": "Lotus Temple",
    "description": "The Lotus Temple is a Bahá’í House of Worship designed in the shape of a blooming lotus with 27 marble petals. Open to people of all religions, it offers silence, meditation, and spiritual reflection. Surrounded by ponds and gardens, it provides a peaceful escape from the city rush. Lotus Temple is Delhi’s modern symbol of unity and peace."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb is a stunning Mughal mausoleum built in 1570, and is often considered the inspiration for the Taj Mahal. Surrounded by Persian-style gardens and water channels, its symmetrical architecture exudes divine beauty. The red sandstone and white marble create a mesmerizing contrast. Humayun’s Tomb is Delhi’s elegant blend of art and legacy."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a grand cultural complex featuring intricately carved sandstone structures, exhibitions, and a mesmerizing musical fountain show. Built without steel, it showcases over 20,000 statues of deities, sages, and historical figures. The boat ride inside narrates India’s ancient wisdom and inventions. Akshardham is Delhi’s majestic showcase of devotion and craftsmanship."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built by Shah Jahan in 1656, is one of India’s largest mosques accommodating over 25,000 worshippers. The grand courtyard, domes, and minarets reflect classic Mughal architecture. Visitors climb the minaret for panoramic views of Old Delhi. The nearby food lanes of Chandni Chowk offer authentic Mughlai cuisine. Jama Masjid is Delhi’s spiritual icon of heritage."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is a black marble platform marking the cremation site of Mahatma Gandhi. Set amidst peaceful lawns and eternal flames, it evokes deep respect and reverence. World leaders often pay tribute here during their visits. Inspirational quotes surround the memorial. Raj Ghat is Delhi’s solemn tribute to the Father of the Nation."
  },
  {
    "title": "Hauz Khas Village",
    "description": "Hauz Khas Village is a vibrant hub of heritage and nightlife featuring medieval ruins, lake views, art cafes, and designer boutiques. The ancient Hauz Khas Fort offers picturesque sunset views over the water. Trendy restaurants and bars attract youngsters and travelers alike. It blends history with modern lifestyle. Hauz Khas is Delhi’s stylish fusion of past and present."
  },
  {
    "title": "Chandni Chowk & Paranthe Wali Gali",
    "description": "Chandni Chowk is one of Delhi’s oldest and busiest markets filled with spices, jewelry, and fabric stores. Paranthe Wali Gali is famous for its stuffed parathas served with pickles and chutneys. Rickshaws, temples, and street vendors create a chaotic yet charming atmosphere. It’s a paradise for food lovers and shoppers. Chandni Chowk is Delhi’s bustling street of flavors and culture."
  }
],


 "services": [
  {
    "name": "Luxury Cab Services in Delhi",
    "description": "Our Luxury Cab Services in Delhi cater to clients who seek premium comfort, style, and reliability. We offer a fleet of high-end vehicles including luxury sedans, SUVs, and executive cars, all maintained to the highest standards. Whether you need transportation for business meetings, airport transfers, weddings, or special events, our professional chauffeurs ensure a smooth, punctual, and discreet travel experience. With 24x7 availability and online booking, we deliver convenience along with unmatched luxury."
  },
  {
    "name": "Premium Taxi Delhi",
    "description": "Premium Taxi Delhi provides top-tier taxi services featuring elegant vehicles and courteous drivers trained to offer an exceptional travel experience. Ideal for corporate travelers, tourists, and anyone wanting a sophisticated ride, our taxis come with amenities such as leather interiors, climate control, and on-demand Wi-Fi, ensuring every trip is comfortable and productive."
  },
  {
    "name": "Chauffeur Driven Luxury Car Delhi",
    "description": "Experience the pinnacle of luxury with our Chauffeur Driven Luxury Cars in Delhi. Our chauffeurs are professionally trained to provide courteous, discreet, and safe service, making these rides perfect for executives, VIPs, and special occasions. Choose from a wide range of luxury models, all equipped with modern amenities to guarantee comfort and style throughout your journey."
  },
  {
    "name": "Executive Cab Delhi",
    "description": "Executive Cab Delhi is designed for business professionals who demand punctuality, privacy, and a premium travel environment. Our executive cabs are ideal for airport transfers, client meetings, and corporate events, offering plush seating, Wi-Fi connectivity, and a serene atmosphere conducive to work or relaxation during transit."
  },
  {
    "name": "Luxury Sedan Hire Delhi",
    "description": "Our Luxury Sedan Hire service in Delhi offers a sophisticated option for those who want to travel in style without compromising on comfort. Choose from a variety of top-brand sedans with chauffeur services for weddings, business travel, or leisure. Every vehicle is maintained meticulously to ensure a smooth ride and impressive presentation."
  },
  {
    "name": "Luxury SUV Rental Delhi",
    "description": "Luxury SUV Rental in Delhi provides spacious and powerful vehicles suited for groups or those requiring extra comfort and luggage space. Perfect for corporate travel, family outings, or airport transfers, our SUVs come with plush interiors, advanced safety features, and professional chauffeurs to ensure a premium experience."
  },
  {
    "name": "Corporate Luxury Cab Delhi",
    "description": "Corporate Luxury Cab Delhi offers bespoke travel solutions for companies seeking premium transportation for their executives and guests. Our corporate packages include monthly rentals, event-specific bookings, and airport transfers with fully equipped luxury vehicles, GPS tracking, and priority support, all designed to enhance your company’s brand image and travel comfort."
  },
  {
    "name": "Best Luxury Cab Delhi",
    "description": "Recognized as the Best Luxury Cab service in Delhi, we pride ourselves on delivering exceptional service quality, well-maintained premium vehicles, and highly trained chauffeurs. Our commitment to safety, punctuality, and customer satisfaction makes us the preferred choice for discerning travelers across Delhi NCR."
  },
  {
    "name": "Affordable Luxury Cab Delhi",
    "description": "Affordable Luxury Cab Delhi combines elegance with cost-effectiveness, providing access to premium vehicles and chauffeur services without the exorbitant price tag. Ideal for those who want to experience luxury travel on a budget, our service maintains high standards of comfort and professionalism."
  },
  {
    "name": "Online Luxury Cab Booking Delhi",
    "description": "With Online Luxury Cab Booking in Delhi, you can effortlessly schedule your premium rides via a user-friendly platform. Enjoy instant confirmations, easy cancellations, real-time tracking, and multiple payment options. Whether for immediate rides or advance bookings, our online service ensures convenience alongside luxury."
  },
  {
    "name": "Wedding Luxury Cab Delhi",
    "description": "Make your special day unforgettable with our Wedding Luxury Cab services in Delhi. We provide elegant, chauffeur-driven luxury cars and SUVs perfect for wedding processions, guest transfers, and VIP travel. Our team ensures timely arrivals, stylish vehicles, and a hassle-free experience tailored to the grandeur of your event."
  },
  {
    "name": "Airport Luxury Taxi Delhi",
    "description": "Airport Luxury Taxi Delhi offers premium transportation to and from all major airports in Delhi. Our luxury vehicles provide comfort and style after long flights, with chauffeurs who track flight times to ensure punctual pickups and drop-offs. Enjoy a seamless, stress-free airport transfer experience with luggage assistance and courteous service."
  },
  {
    "name": "Premium Transport Delhi",
    "description": "Premium Transport Delhi delivers high-end travel solutions tailored for corporate clients, VIPs, and discerning individuals. Our fleet includes luxury sedans, SUVs, and limousines, all driven by professional chauffeurs trained to provide an impeccable blend of safety, comfort, and discretion on every journey."
  },
  {
    "name": "Luxury Car Hire Delhi",
    "description": "Luxury Car Hire Delhi offers an extensive selection of high-end vehicles available for hourly, daily, or long-term rental. Whether you need a car for business trips, leisure, or special events, our luxury fleet is maintained to the highest standards and driven by experienced chauffeurs dedicated to delivering excellence."
  },
  {
    "name": "Luxury Cab Packages Delhi",
    "description": "Our Luxury Cab Packages in Delhi are designed to meet diverse needs, from corporate accounts and airport transfers to weddings and sightseeing tours. Packages can be customized based on duration, vehicle type, and additional services like in-car amenities or event coordination, providing clients with flexible and cost-effective luxury travel options."
  }
],
"tableData": [
  ["Luxury Cab Services in Delhi", "Premium Taxi Delhi"],
  ["Chauffeur Driven Luxury Car Delhi", "Executive Cab Delhi"],
  ["Luxury Sedan Hire Delhi", "Luxury SUV Rental Delhi"],
  ["Corporate Luxury Cab Delhi", "Best Luxury Cab Delhi"],
  ["Affordable Luxury Cab Delhi", "Online Luxury Cab Booking Delhi"],
  ["Wedding Luxury Cab Delhi", "Airport Luxury Taxi Delhi"],
  ["Premium Transport Delhi", "Luxury Car Hire Delhi"],
  ["Luxury Cab Packages Delhi", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Premium Luxury Cab Services in Delhi",
    "WhyChoosedescription": "Aaryan Travels provides top-tier luxury cab services in Delhi, ensuring a sophisticated and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Fleet of High-End Vehicles",
    "WhyChoosedescription": "Choose from luxury sedans, SUVs, and premium cars maintained to the highest standards for your comfort and style."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs with Discreet Service",
    "WhyChoosedescription": "Our experienced and courteous drivers ensure safe, punctual, and discreet rides."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in sanitized, immaculate vehicles equipped with modern amenities for a premium experience."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing covering fuel, tolls, and driver allowances without any surprises."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Bookings",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with your luxury cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Business or Leisure",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance luxury travel."
  },
  {
    "WhyChooseheading": "Commitment to Safety and Customer Satisfaction",
    "WhyChoosedescription": "We prioritize your safety and satisfaction, ensuring a smooth and elegant travel experience every time."
  }
]




























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury cab services in Delhi?',
    answer: 'Yes, Aaryan Travels provides premium luxury cab services in Delhi with high-end vehicles and professional chauffeurs.',
  },
  {
    question: 'How can I book luxury cab services in Delhi with Aaryan Travels?',
    answer: 'You can easily book luxury cabs through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of luxury vehicles are available for cab services in Delhi?',
    answer: 'We offer a range of luxury cars including Mercedes, BMW, Audi, and other premium brands for your comfort and style.',
  },
  {
    question: 'Are the drivers for luxury cabs trained and professional?',
    answer: 'Absolutely. Our chauffeurs are professionally trained, courteous, and well-versed in providing a premium travel experience.',
  },
  {
    question: 'Is luxury cab service available for both local and outstation travel in Delhi?',
    answer: 'Yes, Aaryan Travels offers luxury cab services for local rides as well as outstation trips from Delhi.',
  },
  {
    question: 'Can I book luxury cabs for special occasions in Delhi?',
    answer: 'Yes, our luxury cab services are perfect for weddings, corporate events, airport transfers, and other special occasions.',
  },
  {
    question: 'Is luxury cab service in Delhi available 24x7?',
    answer: 'Yes, we provide 24x7 luxury cab booking and services in Delhi to meet your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for luxury cabs in Delhi?',
    answer: 'All luxury vehicles are sanitized regularly, and chauffeurs follow strict safety and hygiene protocols for your protection.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for luxury cab bookings in Delhi?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points as per your travel plans.',
  },
  {
    question: 'What payment options are accepted for luxury cab services in Delhi?',
    answer: 'We accept cash, cards, UPI, and popular digital wallets for hassle-free payments.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajiv Malhotra',
    feedback: 'The luxury cab service by Aaryan Travels in Delhi was exceptional. The car was comfortable, and the driver was professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Gupta',
    feedback: 'Aaryan Travels provided an excellent luxury cab experience in Delhi. Highly recommended for special occasions.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Cab Services in Delhi",
  "image": "https://aaryantravels.com/assets/images/luxury-cab-services-in-delhi.jpg", // replace with actual image URL
  "description": "Aaryan Travels offers premium luxury cab services in Delhi with professional chauffeurs. Choose from high-end sedans and SUVs for corporate, airport transfers, weddings, and personal travel.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // example rating
    "ratingCount": "4200", // example rating count
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",  // example base fare
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/luxury-cab-services-in-delhi"
  }
};






  return (
    <div>
<Helmet>
  <title>Luxury Cab Services in Delhi | Premium Chauffeur Cars & Sedans | Aaryan Travels</title>
  <meta
    name="description"
    content="Experience premium luxury cab services in Delhi with Aaryan Travels. Book chauffeur-driven sedans and SUVs for corporate, airport, wedding, or personal travel at affordable rates."
  />
  <meta
    name="keywords"
    content="Luxury Cab Services in Delhi, Premium Taxi Delhi, Chauffeur Driven Luxury Car Delhi, Executive Cab Delhi, Luxury Sedan Hire Delhi, Luxury SUV Rental Delhi, Corporate Luxury Cab Delhi, Best Luxury Cab Delhi, Affordable Luxury Cab Delhi, Online Luxury Cab Booking Delhi, Wedding Luxury Cab Delhi, Airport Luxury Taxi Delhi, Premium Transport Delhi, Luxury Car Hire Delhi, Luxury Cab Packages Delhi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/42.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurycabserviceindelhi;